function minLength(string, min) {
  return string.length >= min
}

function isNumeric(value) {
  let re = /^[0-9]*$/
  return re.test(value)
}

function validEmail (email) {
  let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

function validPhone (number) {
  let re = /^[0-9+-\s]*$/
  return re.test(number)
}

export { minLength, isNumeric, validEmail, validPhone }
